// /src/pages/404.jsx
import React from "react";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <Helmet>
        <title>Page Not Found — Andlegur</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="w-full max-w-lg space-y-12">

        {/* ===============================
         2. Playful & Helpful Version
         =============================== */}
        <section className="text-center border rounded-2xl shadow-md p-12 bg-gradient-to-b from-indigo-50 to-white">
          {/* Big 404 title before any content */}
          <h1 className="text-6xl font-extrabold text-indigo-900 mb-6">
            404 –Page Not Found
          </h1>
          <p className="text-lg text-gray-700 mb-6">
            Oops! This space doesn’t exist (yet).  
            But don’t worry, you can always find your way back to purpose.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <Link
              to="/"
              className="px-6 py-3 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition"
            >
              Take me Home
            </Link>
            <Link
              to="/sanctuary"
              className="px-6 py-3 rounded-xl bg-white border border-indigo-300 text-indigo-700 font-medium hover:bg-indigo-50 transition"
            >
              Visit the Sanctuary ✨
            </Link>
          </div>

          {/* Optional: quick links */}
          <div className="mt-10 space-x-4 text-sm text-gray-500">
            <Link to="/community" className="hover:text-indigo-600">
              Join the Community
            </Link>
            <span>•</span>
            <Link to="/about" className="hover:text-indigo-600">
              Meet the Archetypes
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
